import { useAuthData } from '@auth/shared/model';
import { trpc } from '@/shared/api/trpc';

export const useCurrentOrganization = () => {
  const { data: authData, isLoading: authLoading } = useAuthData();
  const orgId = authData?.organization?.id;
  const query = trpc.organizations.findOne.useQuery(
    { id: orgId as string },
    { enabled: !!orgId }
  );
  return {
    organizationId: orgId,
    organization: query.data,
    isLoading: authLoading || (!!orgId && query.isLoading),
    isError: query.isError,
    error: query.error,
  };
};
